"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ProductInfo = _interopRequireDefault(require("./ProductInfo/ProductInfo"));
var _ProductMatch = _interopRequireDefault(require("./ProductMatch"));
var _DynamicTopFeatures = _interopRequireDefault(require("../../ThemeBasedComponents/DynamicTopFeatures"));
var _RefurbishedProduct = _interopRequireDefault(require("./RefurbishedProduct"));
var _useRecommendationHandset = require("../../../hooks/recommendation/useRecommendationHandset");
var _RecommendationFooter = _interopRequireDefault(require("../RecommendationFooter"));
var _useConfig = _interopRequireDefault(require("../../../hooks/useConfig"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const DisplayMatchingOrRefurbishedPolicy = props => {
  var _filters$refurbishedC;
  const {
    handset
  } = props;
  const {
    filters
  } = (0, _useRecommendationHandset.useRecommendationHandset)(handset);
  if (filters !== null && filters !== void 0 && (_filters$refurbishedC = filters.refurbishedCondition) !== null && _filters$refurbishedC !== void 0 && _filters$refurbishedC.isRefurbishedHandset) return /*#__PURE__*/_react.default.createElement(_RefurbishedProduct.default, props);
  return /*#__PURE__*/_react.default.createElement(_ProductMatch.default, props);
};
const ProductCard = props => {
  const showStickyFooter = (0, _useConfig.default)("uiSettings.showStickyFooter", false);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ProductInfo.default, props), /*#__PURE__*/_react.default.createElement(DisplayMatchingOrRefurbishedPolicy, props), /*#__PURE__*/_react.default.createElement(_DynamicTopFeatures.default, props), !showStickyFooter && /*#__PURE__*/_react.default.createElement(_RecommendationFooter.default, null));
};
var _default = ProductCard;
exports.default = _default;